import { Link } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card.tsx';

export function ReportsPage() {
  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-3xl font-bold'>Reports</h1>
        <p className='text-muted-foreground mt-1'>Operational reports and data exports</p>
      </div>

      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
        <Link to='/reports/call-in-cadence' className='block'>
          <Card className='hover:bg-accent/50 transition-colors cursor-pointer h-full'>
            <CardHeader className='pb-2'>
              <div className='flex items-center gap-2'>
                <BarChart3 className='h-5 w-5 text-muted-foreground' />
                <CardTitle className='text-lg'>Call-in Cadence</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Per-meter call-in frequency and timing for a selected customer. Identify silent,
                sparse, or irregular reporting devices.
              </CardDescription>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
